import superagent from '@ott/superagent';
import T from '../types';
import prepareSuggestions from '../helpers/prepareSuggestions';

let currentReq = null;

export default function getSuggestions(query) {
  return {
    // eslint-disable-next-line consistent-return
    promise: async () => {
      if (currentReq) {
        currentReq.abort();
      }

      const response = await (currentReq = superagent
        .get('/_tours/v2/getDestinationSuggest/')
        .query({
          query,
          showHotels: true,
        }));

      if (response) {
        const {
          body: { result },
        } = response;

        return prepareSuggestions(result);
      }
    },
    types: [
      T.GET_DESTINATION_SUGGESTIONS_BEGIN,
      T.GET_DESTINATION_SUGGESTIONS_SUCCESS,
      T.GET_DESTINATION_SUGGESTIONS_FAIL,
    ],
  };
}
